/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalGrillW42Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalGrillW42').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRILL_LYNX_PROFESSIONAL_L42',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-grill-w-42.js.map